import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../stores/Hooks';

export const ValidationStatusComponent: React.FC<any> = observer(
	() =>
	{
		const { uiState } = useStores();

		return (
			<div className="form-steps-progress">
				<div className={"form-step d-flex" + (uiState.register.IsValid ? " passed" : "")}>
					<div className="form-step-icon mr-2"></div>
					<div className="form-step-text">
						<p className="mb-0">Регистрационные данные</p>
						<div className="step-error">{uiState.register.ValidationMessage}</div>
					</div>
				</div>
				<div className={"form-step d-flex" + (uiState.info.IsValid ? " passed" : "")}>
					<div className="form-step-icon mr-2"></div>
					<div className="form-step-text">
						<p className="mb-0">Сведения об операторе ЭДО</p>
						<div className="step-error">{uiState.info.ValidationMessage}</div>
					</div>
				</div>
				<div className={"form-step d-flex" + (uiState.files.IsValid ? " passed" : "")}>
					<div className="form-step-icon mr-2"></div>
					<div className="form-step-text">
						<p className="mb-0">Документы оператора ЭДО</p>
						<div className="step-error">{uiState.files.ValidationMessage}</div>
					</div>
				</div>
			</div>
		);
	}
)
